import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import redditApi from '../../services/redditApi';
import './reddit.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await redditApi.post('/auth/password-reset/', { email });
      setSent(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="rh-auth-page">
      <div className="rh-auth-card">
        <div className="rh-auth-brand">
          <div className="rh-brand-icon">R</div>
          <div>
            <h1 className="rh-auth-title">Forgot Password</h1>
            <p className="rh-auth-subtitle">Reddit Campaign Hub</p>
          </div>
        </div>

        {sent ? (
          <div style={{ textAlign: 'center', padding: '8px 0 16px' }}>
            <div style={{
              width: 56, height: 56, borderRadius: '50%', background: 'rgba(255,69,0,0.1)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px',
            }}>
              <svg width="26" height="26" fill="none" stroke="var(--rh-orange)" strokeWidth="2.5" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="4" width="20" height="16" rx="2"/>
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
              </svg>
            </div>
            <p style={{ margin: '0 0 6px', fontWeight: 600, color: 'var(--rh-text)' }}>Check your inbox</p>
            <p style={{ margin: 0, fontSize: 13, color: 'var(--rh-text-muted)', lineHeight: 1.6 }}>
              If <strong>{email}</strong> is registered, you'll receive a reset link shortly. The link expires in 30 minutes.
            </p>
            <Link
              to="/reddit/login"
              style={{ display: 'inline-block', marginTop: 24, color: 'var(--rh-orange)', fontWeight: 600, fontSize: 14, textDecoration: 'none' }}
            >
              ← Back to Sign in
            </Link>
          </div>
        ) : (
          <>
            <p style={{ margin: '0 0 20px', fontSize: 14, color: 'var(--rh-text-muted)', lineHeight: 1.6 }}>
              Enter your email address and we'll send you a link to reset your password.
            </p>
            {error && <div className="rh-auth-error">{error}</div>}
            <form onSubmit={onSubmit} className="rh-auth-form">
              <div className="rh-field">
                <label htmlFor="fp-email">Email</label>
                <input
                  id="fp-email"
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                />
              </div>
              <button type="submit" className="rh-btn-primary" disabled={busy}>
                {busy ? 'Sending…' : 'Send reset link'}
              </button>
            </form>
            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <Link
                to="/reddit/login"
                style={{ fontSize: 13, color: 'var(--rh-text-muted)', textDecoration: 'none' }}
              >
                ← Back to Sign in
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
